import axios from "axios";

let location = window.location.origin;
const API = `${location}/api/register`;
export default {
    get(data) {},
    create(data) {
        return axios.post(API, data);
    }
};